import(/* webpackMode: "eager" */ "/opt/buildhome/repo/src/app/acesso/page.tsx");
